module.exports = __webpack_public_path__ + "static/img/tutorial.91a01f90.png";